import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

import { GroupedNavigationLinks } from '../../../../core/models/grouped-navigation-links';
import { getHeaderLinksCopy } from '../constants/header-links';

import { HeaderDropdownComponent } from '../header-dropdown/header-dropdown.component';

@Component({
    selector: 'app-header-mobile',
    templateUrl: './header-mobile.component.html',
    styleUrl: './header-mobile.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MatMenuModule,
        MatIconModule,
        MatButtonModule,
        HeaderDropdownComponent,
    ],
})
export class HeaderMobileComponent {
    @Input() isLoggedIn!: boolean;
    headerLinks: GroupedNavigationLinks[] = getHeaderLinksCopy();

    showDetails: { [key: string]: boolean } = {};

    toggleDetails(event: MouseEvent, item: string): void {
        event.stopPropagation(); // Prevent menu from closing
        this.showDetails[item] = !this.showDetails[item];
    }
}
